export default "__VITE_ASSET__Cl5ZvZ5K__"